import { render, staticRenderFns } from "./CameraCapture.vue?vue&type=template&id=6278ea86&"
import script from "./CameraCapture.vue?vue&type=script&lang=js&"
export * from "./CameraCapture.vue?vue&type=script&lang=js&"
import style0 from "./CameraCapture.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports